export default __webpack_public_path__ + "static/media/equallywed_collage.93386c1a.png";